// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H11.5V17C11.5 13.4101 14.4101 10.5 18 10.5C19.0821 10.5 20.1025 10.7644 21 11.2322V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.001 14.5C17.3106 14.5 16.751 15.0596 16.751 15.75V16.5H22.5V23H13.5V16.5H14.751V15.75C14.751 13.9551 16.2061 12.5 18.001 12.5C18.8945 12.5 19.7055 12.8619 20.292 13.4448L21.0013 14.1498L19.5914 15.5683L18.8821 14.8634C18.6551 14.6377 18.3451 14.5 18.001 14.5Z"}}]};

const FileUnlockedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-unlocked-filled',
    ref,
    icon: element,
  },
));

FileUnlockedFilledIcon.displayName = 'FileUnlockedFilledIcon';

export default FileUnlockedFilledIcon;
